import React from 'react';

// theme
import aampeTheme from '../../../constants/aampeTheme';

// components
import BasicSection from './basicSection';

interface TitledSectionProps {
    title?: string;
    sectionStyle?: React.CSSProperties;
    isLoading?: boolean;
    isError?: boolean;
    error?: string;
    style?: React.CSSProperties;
    titleStyle?: React.CSSProperties;
    headingStyle?: React.CSSProperties;
}

const TitledSection: React.FC<React.PropsWithChildren<TitledSectionProps>> = ({
    title,
    children,
    sectionStyle,
    isLoading,
    isError,
    error,
    style,
    titleStyle,
    headingStyle,
}) => {
    return (
        <div
            style={{
                width: '100%',
                ...style,
            }}
        >
            <div
                style={{ marginBottom: aampeTheme.spacing4(2), ...titleStyle }}
            >
                <h2 style={headingStyle}>{title}</h2>
            </div>
            <BasicSection
                isLoading={isLoading}
                isError={isError}
                error={error}
                style={sectionStyle}
            >
                {children}
            </BasicSection>
        </div>
    );
};

export default TitledSection;
